import React from 'react';
import IframeWidget from "../../utils/IframeWidget";
import {Modal} from "react-bootstrap";
import MenuProductListItemComponent from "../../pages/Menu/components/List/MenuProductListItemComponent";
import AppConfig from "../../services/AppConfig";
import {usePrefix} from "../../services/Prefix";
import {useNavigate} from "react-router-dom";
import ItemViewHelper from "../../services/Menu/services/Item/ItemViewHelper";
import {useTranslation} from "react-i18next";

interface Props {
    show: boolean;
    onHide: () => void;
    items: any[];
    findMenuForPromotionItem: (promotionItem: any) => number | undefined;
    promotions: any[];
    availabilities: any[];
    session: any;
    cart: any;
}

const VoucherProductsModal = ({show, onHide, findMenuForPromotionItem, items, promotions, availabilities, session, cart}: Props) => {
    const prefix = usePrefix();
    const navigate = useNavigate();
    const {t} = useTranslation();

	return (
        <Modal dialogClassName={"modal-full voucher-products-modal"} show={show} onHide={() => IframeWidget.onHide(onHide)}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {t("modules.voucher.field.choose_product.title")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex flex-column w-100">
                    {
                        items.map((item, index) => {
                            const menuId = findMenuForPromotionItem(item);
                            const parsedItem = ItemViewHelper.parseItem(item, availabilities, promotions, session.pickup_at, undefined, cart, session.order_type);

                            return (
                                <React.Fragment key={item.id}>
                                    <MenuProductListItemComponent  menuId={menuId}
                                                                  product={parsedItem}
                                                                  promotions={promotions}
                                                                  addItem={() =>  navigate(AppConfig.getLinkWithPrefix(`/menu/${menuId}/add/${item.id}`, prefix), {state: {back: true}})}
                                    />
                                    {index !== items.length - 1 && <hr/>}
                                </React.Fragment>
                            )
                        })
                    }
                </div>
            </Modal.Body>
        </Modal>
	)
}

export default VoucherProductsModal;